<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form
                    class="form-inline my-2 my-lg-0"
                    v-on:keypress.enter.prevent="searchEmployee"
                >
                    <input
                        v-model="search.passport"
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="เลขบัตรประชาชน / passport"
                        aria-label="Search"
                    />
                    <input
                        v-model="search.insurance_card_number"
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="เลขประกันสังคม"
                        aria-label="Search"
                    />
                    <input
                        v-model="search.myanmar_list"
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="เลข ทร.38"
                        aria-label="Search"
                    />
                    <b-form-select
                        :options="optionDepartment"
                        v-model="search.department"
                    >
                    </b-form-select>
                    <multiselect
                        class="form-control select"
                        v-model="search.shift"
                        :options="optionShiftEmployee"
                        label="name"
                        :show-labels="false"
                        select-label=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="เลือกกะการทำงาน"
                        track-by="id"
                    >
                    </multiselect>
                    <multiselect
                        class="form-control select"
                        v-model="search.employee"
                        :options="optionEmployee"
                        :customLabel="employeeLabel"
                        :show-labels="false"
                        select-label=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="ค้นหาพนักงาน"
                        track-by="id"
                    >
                    </multiselect>
                    <b-form-select
                        :options="optionActive"
                        v-model="search.active"
                    >
                    </b-form-select>
                    <button
                        class="btn btn-success mr-sm-2 my-2"
                        @click="searchEmployee"
                        type="button"
                    >
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    <button
                        class="btn btn-warning my-2 my-sm-0"
                        @click="addEmployee"
                        type="button"
                    >
                        <icon name="plus"></icon>
                        เพิ่มพนักงาน
                    </button>
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="showFilterListModal"
                        type="button"
                    >
                        <icon name="print"></icon>
                        รายงาน VISA หมดอายุ
                    </button>
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="showFilterModal"
                        type="button"
                    >
                        <icon name="print"></icon>
                        รายงานรายชื่อพนักงาน
                    </button>
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="showFilterNationModal"
                        type="button"
                    >
                        <icon name="print"></icon>
                        รายงานประกันสังคม
                    </button>
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="showFilterGuaranteeModal"
                        type="button"
                    >
                        <icon name="print"></icon>
                        รายงานเงินค้ำประกัน
                    </button>
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="showFilterNationalityModal"
                        type="button"
                    >
                        <icon name="print"></icon>
                        รายงานข้อมูลสัญชาติ
                    </button>
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="showFilterLeaveModal"
                        type="button"
                    >
                        <icon name="print"></icon>
                        รายงานบันทึกลาออก
                    </button>
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="showFilterHistoryModal"
                        type="button"
                    >
                        <icon name="print"></icon>
                        รายงานข้อมูลพนักงาน
                    </button>
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="showFilterTaxEmployeeModal"
                        type="button"
                    >
                        <icon name="print"></icon>
                        รายงานภาษี
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                    <tr>
                        <th scope="col">ลำดับ</th>
                        <th scope="col">รหัสพนักงาน</th>
                        <th scope="col">เลขบัตรประชาชน/พาสปอร์ต</th>
                        <th scope="col">คำนำหน้าชื่อ</th>
                        <th scope="col">ชื่อ-นามสกุล</th>
                        <th scope="col">ชื่อ อังกฤษ</th>
                        <th scope="col">แผนก</th>
                        <th scope="col">กะทำงาน</th>
                        <th scope="col">สัญชาติ</th>
                        <th scope="col">สถานะ</th>
                        <th scope="col">เงินประกันสังคม</th>
                        <th scope="col">อนุมัติพนักงาน</th>
                        <th scope="col">แก้ไข</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(data, index) in employeeList">
                        <td>
                            {{
                                (dataPaginate.current_page - 1) * 10 +
                                    (index + 1)
                            }}
                        </td>
                        <td>{{ data.employee_no }}</td>
                        <td>
                            <template v-if="data.citizen">
                                {{ data.citizen.citizen_id }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>{{ data.prefix_name }}</td>
                        <td>
                            {{ data.first_name }}
                            {{ data.last_name ? data.last_name : "" }}
                        </td>
                        <td>
                            {{ data.english_name ? data.english_name : "-" }}
                        </td>
                        <td>
                            {{
                                data.occupation && data.occupation.department
                                    ? data.occupation.department.department_name
                                    : "-"
                            }}
                        </td>
                        <td>
                            {{
                                data.occupation && data.occupation.shift
                                    ? data.occupation.shift.name
                                    : "-"
                            }}
                        </td>
                        <td>
                            <template v-if="data.nationality">
                                {{ data.nationality.nationality_name }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template
                                v-if="
                                    data.work_status &&
                                        data.work_status.active_status_id == 3
                                "
                            >
                                <span
                                    v-if="canViewSuperAdmin"
                                    @click="showApproveResignModal(data.id)"
                                    style="text-decoration: underline;color: red;cursor: pointer"
                                    >{{
                                        data.work_status.active_status_name
                                    }}</span
                                >
                                <span
                                    v-else
                                    style="text-decoration: underline;color: grey;cursor: pointer"
                                    >{{
                                        data.work_status.active_status_name
                                    }}</span
                                >
                            </template>
                            <template
                                v-else-if="
                                    data.work_status &&
                                        data.work_status.active_status_id != 3
                                "
                            >
                                {{ data.work_status.active_status_name }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            {{
                                data.cumulative_social_security
                                    ? data.cumulative_social_security
                                    : 0 | currency
                            }}
                        </td>
                        <td>
                            <template v-if="data.is_approve">
                                <span style="color: green">{{
                                    data.approve
                                }}</span>
                            </template>
                            <template v-else>
                                <a
                                    style="color: red ; text-decoration: underline"
                                    @click="showApproveModal(data.id)"
                                    v-if="canViewSuperAdmin"
                                >
                                    {{ data.approve }}
                                </a>
                                <!--                            <a style="color: red ; text-decoration: underline" @click="showApproveModal(data.id)" v-else>-->
                                <!--                                {{data.approve}}-->
                                <!--                            </a>-->
                            </template>
                        </td>
                        <td>
                            <a @click="editEmployee(data.id)">
                                <icon name="pencil-alt"></icon> </a
                            >&nbsp;
                            <a @click="showDeleteModal(data.id)">
                                <icon name="trash-alt"></icon>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="employeeList.length > 0">
            <vue-pagination :pagination="dataPaginate" @paginate="getEmployee">
            </vue-pagination>
        </div>
        <br />
        <!--modal-->
        <b-modal hide-header hide-footer ref="approve" centered>
            <confirm-modal
                msg="คุณต้องการอนุมัติพนักงานใช่หรือไม่ ?"
                @submit="approveEmployee"
            >
            </confirm-modal>
        </b-modal>
        <!--modal-->
        <b-modal hide-header hide-footer ref="resign" centered>
            <confirm-modal
                msg="คุณต้องการอนุมัติลาออกพนักงานใช่หรือไม่ ?"
                @submit="approveResignEmployee"
            >
            </confirm-modal>
        </b-modal>
        <!--modal-->
        <b-modal hide-header hide-footer ref="delete_item">
            <confirm-modal
                msg="คุณต้องการลบพนักงานใช่หรือไม่ ?"
                @submit="deleteEmployee"
            >
            </confirm-modal>
        </b-modal>

        <b-modal hide-header hide-footer ref="filter_list">
            <filter-list-modal @submit="filterExpire"></filter-list-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="filter_emp">
            <div class="row">
                <div class="col-3">สถานะ</div>
                <div class="col-9">
                    <b-form-select :options="optionActive" v-model="emp.active">
                    </b-form-select>
                </div>
                <!--                <div class="col-3 mt-4">วันที่</div>-->
                <!--                <div class="col-9 mt-4">-->
                <!--                    <date-picker-->
                <!--                        v-model="emp.date"-->
                <!--                        type="date"-->
                <!--                        :format="changeFormat"-->
                <!--                        :lang="lang"-->
                <!--                        range-->
                <!--                        class="w-100"-->
                <!--                        placeholder="วันที่" confirm>-->
                <!--                    </date-picker>-->
                <!--                </div>-->
                <div class="col-3 mt-4">
                    พนักงาน
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        v-model="emp.employee"
                        :options="optionEmployee"
                        :customLabel="employeeLabel"
                        :show-labels="false"
                        select-label=""
                        multiple
                        :close-on-select="false"
                        style="height: 100%"
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="ค้นหาพนักงาน"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-3 mt-4">
                    แผนก
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        :options="optionDepartmentEmp"
                        v-model="emp.department"
                        label="department_name"
                        select-label=""
                        multiple
                        :closeOnSelect="false"
                        style="height: 100%"
                        deselectLabel=""
                        placeholder="แผนก"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-6 text-center mt-4">
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="empToPDF"
                        type="button"
                    >
                        PDF
                    </button>
                </div>
                <div class="col-6 text-center mt-4">
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="empToExcel"
                        type="button"
                    >
                        Excel
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="filter_tax_employee">
            <div class="row">
                <div class="col-3 mt-4">วันที่</div>
                <div class="col-9 mt-4">
                    <date-picker
                        v-model="emp_tax.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        class="w-100"
                        placeholder="วันที่"
                        confirm
                    >
                    </date-picker>
                </div>
                <div class="col-3 mt-4">
                    พนักงาน
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        v-model="emp_tax.employee"
                        :options="optionEmployee"
                        :customLabel="employeeLabel"
                        :show-labels="false"
                        select-label=""
                        multiple
                        :close-on-select="false"
                        style="height: 100%"
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="ค้นหาพนักงาน"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-3 mt-4">
                    แผนก
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        :options="optionDepartmentEmp"
                        v-model="emp_tax.department"
                        label="department_name"
                        select-label=""
                        multiple
                        :closeOnSelect="false"
                        style="height: 100%"
                        deselectLabel=""
                        placeholder="แผนก"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-6 text-center mt-4">
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="empTaxToPDF"
                        type="button"
                    >
                        PDF
                    </button>
                </div>
                <div class="col-6 text-center mt-4">
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="empTaxToExcel"
                        type="button"
                    >
                        Excel
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="filter_emp_nation">
            <div class="row">
                <div class="col-3">สถานะ</div>
                <div class="col-9">
                    <b-form-select
                        :options="optionActive"
                        v-model="emp_nation.active"
                    >
                    </b-form-select>
                </div>
                <div class="col-3 mt-4">
                    พนักงาน
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        v-model="emp_nation.employee"
                        :options="optionEmployee"
                        :customLabel="employeeLabel"
                        :show-labels="false"
                        select-label=""
                        multiple
                        :close-on-select="false"
                        style="height: 100%"
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="ค้นหาพนักงาน"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-3 mt-4">
                    แผนก
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        :options="optionDepartmentEmp"
                        v-model="emp_nation.department"
                        label="department_name"
                        select-label=""
                        multiple
                        :closeOnSelect="false"
                        style="height: 100%"
                        deselectLabel=""
                        placeholder="แผนก"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <!--                <div class="col-3 mt-4">-->
                <!--                    สัญชาติ-->
                <!--                </div>-->
                <!--                <div class="col-9 mt-4">-->
                <!--                    <multiselect-->
                <!--                        :options="passport_type"-->
                <!--                        v-model="emp_nation.nationality"-->
                <!--                        label="name"-->
                <!--                        select-label=""-->
                <!--                        multiple-->
                <!--                        :closeOnSelect="false"-->
                <!--                        style="height: 100%"-->
                <!--                        deselectLabel=""-->
                <!--                        placeholder="สัญชาติ"-->
                <!--                        track-by="id">-->
                <!--                    </multiselect>-->
                <!--                </div>-->
                <div class="col-3 mt-4">สัญชาติ</div>
                <div class="col-4 mt-4">
                    <input
                        type="checkbox"
                        value="1"
                        id="nationality1"
                        v-model="emp_nation.nationality"
                    />
                    <label for="nationality1" class="ml-3">คนไทย</label>
                </div>
                <div class="col-4 mt-4">
                    <input
                        type="checkbox"
                        value="2"
                        id="nationality2"
                        v-model="emp_nation.nationality"
                    />
                    <label for="nationality2" class="ml-3">ต่างชาติ</label>
                </div>
                <div class="col-3 mt-4">
                    วันที่
                </div>
                <div class="col-9 mt-4">
                    <date-picker
                        type="month"
                        class="mr-2"
                        v-model="emp_nation.date"
                        :range="false"
                        placeholder="เดือน"
                        :lang="lang"
                        confirm
                        :format="changeFormatMonth"
                        style="width: 100%;"
                    >
                    </date-picker>
                </div>
                <div class="col-12 text-center mt-4">
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="empNationToExcel"
                        type="button"
                    >
                        Excel
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="filter_emp_guarantee">
            <div class="row">
                <div class="col-3">สถานะ</div>
                <div class="col-9">
                    <b-form-select
                        :options="optionActive"
                        v-model="emp_guarantee.active"
                    >
                    </b-form-select>
                </div>
                <div class="col-3 mt-4">
                    พนักงาน
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        v-model="emp_guarantee.employee"
                        :options="optionEmployee"
                        :customLabel="employeeLabel"
                        :show-labels="false"
                        select-label=""
                        multiple
                        :close-on-select="false"
                        style="height: 100%"
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="ค้นหาพนักงาน"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-3 mt-4">
                    แผนก
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        :options="optionDepartmentEmp"
                        v-model="emp_guarantee.department"
                        label="department_name"
                        select-label=""
                        multiple
                        :closeOnSelect="false"
                        style="height: 100%"
                        deselectLabel=""
                        placeholder="แผนก"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-6 text-center mt-4">
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="empGuaranteeToPDF"
                        type="button"
                    >
                        PDF
                    </button>
                </div>
                <div class="col-6 text-center mt-4">
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="empGuaranteeToExcel"
                        type="button"
                    >
                        Excel
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="filter_emp_nationality">
            <div class="row">
                <div class="col-3">สถานะ</div>
                <div class="col-9">
                    <b-form-select
                        :options="optionActive"
                        v-model="emp_nationality.active"
                    >
                    </b-form-select>
                </div>
                <div class="col-3 mt-4">
                    พนักงาน
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        v-model="emp_nationality.employee"
                        :options="optionEmployee"
                        :customLabel="employeeLabel"
                        :show-labels="false"
                        select-label=""
                        multiple
                        :close-on-select="false"
                        style="height: 100%"
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="ค้นหาพนักงาน"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-3 mt-4">
                    แผนก
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        :options="optionDepartmentEmp"
                        v-model="emp_nationality.department"
                        label="department_name"
                        select-label=""
                        multiple
                        :closeOnSelect="false"
                        style="height: 100%"
                        deselectLabel=""
                        placeholder="แผนก"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-3 mt-4">
                    สัญชาติ
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        :options="passport_type"
                        v-model="emp_nationality.passport_type"
                        label="name"
                        select-label=""
                        multiple
                        :closeOnSelect="false"
                        style="height: 100%"
                        deselectLabel=""
                        placeholder="สัญชาติ"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-6 text-center mt-4">
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="empNationalityToPDF"
                        type="button"
                    >
                        PDF
                    </button>
                </div>
                <div class="col-6 text-center mt-4">
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="empNationalityToExcel"
                        type="button"
                    >
                        Excel
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="filter_emp_leave">
            <div class="row">
                <div class="col-3 mt-4">วันที่</div>
                <div class="col-9 mt-4">
                    <date-picker
                        v-model="emp_leave.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        class="w-100"
                        placeholder="วันที่"
                        confirm
                    >
                    </date-picker>
                </div>
                <div class="col-3 mt-4">
                    แผนก
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        :options="optionDepartmentEmp"
                        v-model="emp_leave.department"
                        label="department_name"
                        select-label=""
                        multiple
                        :closeOnSelect="false"
                        style="height: 100%"
                        deselectLabel=""
                        placeholder="แผนก"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-6 text-center mt-4">
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="empLeaveToPDF"
                        type="button"
                    >
                        PDF
                    </button>
                </div>
                <div class="col-6 text-center mt-4">
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="empLeaveToExcel"
                        type="button"
                    >
                        Excel
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="filter_history_leave">
            <div class="row">
                <div class="col-3 mt-4">
                    พนักงาน
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        v-model="emp_history.employee"
                        :options="optionEmployee"
                        :customLabel="employeeLabel"
                        :show-labels="false"
                        select-label=""
                        multiple
                        :close-on-select="false"
                        style="height: 100%"
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="ค้นหาพนักงาน"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-3 mt-4">
                    แผนก
                </div>
                <div class="col-9 mt-4">
                    <multiselect
                        :options="optionDepartmentEmp"
                        v-model="emp_history.department"
                        label="department_name"
                        select-label=""
                        multiple
                        :closeOnSelect="false"
                        style="height: 100%"
                        deselectLabel=""
                        placeholder="แผนก"
                        track-by="id"
                    >
                    </multiselect>
                </div>
                <div class="col-12 text-center mt-4">
                    <button
                        class="btn btn-primary my-2 my-sm-0 ml-2"
                        @click="empHistoryToPDF"
                        type="button"
                    >
                        PDF
                    </button>
                </div>
                <!--                <div class="col-6 text-center mt-4">-->
                <!--                    <button class="btn btn-primary my-2 my-sm-0 ml-2"-->
                <!--                            @click="empLeaveToExcel"-->
                <!--                            type="button">-->
                <!--                            Excel-->
                <!--                    </button>-->
                <!--                </div>-->
            </div>
        </b-modal>

        <!--        <pre class="alert alert-danger">{{optionDepartment}}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import VuePagination from "../../../Pagination";
import ConfirmModal from "../../../Utility/ConfirmModal";
import FilterListModal from "../../../Utility/FilterListModal";
import DatePicker from "vue2-datepicker";
import { domain } from "../../../../util/Constants";
import { canViewSuperAdmin } from "../../../../util/Permissions";
import moment from "moment";

export default {
    components: {
        ConfirmModal,
        VuePagination,
        Multiselect,
        FilterListModal,
        DatePicker
    },
    name: "employee-list",
    created() {
        this.$store.dispatch("Employee/setEmployee");
        this.$store.dispatch("Employee/clearSearch");
        this.$store.dispatch("Common/setPosition");
        this.$store.dispatch("Common/getPassportType");
        this.getEmployeeAll();
        this.getDepartmentAll();
    },
    data() {
        return {
            event_submit: false,
            employee_id: "",
            employee_id_resign: "",
            delete_id: null,
            optionEmployee: [],
            optionDepartment: [],
            optionDepartmentEmp: [],
            optionActive: [
                { text: "เลือกสถานะ", value: "" },
                { text: "พนักงาน", value: 1 },
                { text: "ลาออก", value: 2 },
                { text: "รออนุมติ", value: 3 }
            ],
            emp: {
                department: [],
                active: "",
                employee: []
            },
            emp_tax: {
                department: [],
                employee: [],
                date: []
            },
            emp_nation: {
                department: [],
                active: "",
                employee: [],
                nationality: [],
                date: moment().format("YYYY-MM")
            },
            emp_guarantee: {
                department: [],
                active: "",
                employee: []
            },
            emp_nationality: {
                department: [],
                active: "",
                employee: [],
                passport_type: []
            },
            emp_leave: {
                department: [],
                active: "",
                employee: [],
                date: []
            },
            emp_history: {
                department: [],
                employee: []
            },
            changeFormat: {
                stringify: date => {
                    let date_moment = moment(date).format("YYYY");
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/' + year));
                    return date ? moment(date).format("DD/MM/" + year) : null;
                },
                parse: value => {
                    return value
                        ? moment(value, "DD/MM/YYYY")
                              .subtract(543, "y")
                              .toDate()
                        : null;
                }
            },
            changeFormatMonth: {
                stringify: date => {
                    if (!date) return null;
                    const yearBE = moment(date).year() + 543; // Convert to Buddhist Year
                    return moment(date).format("MM/") + yearBE;
                },
                parse: value => {
                    if (!value) return null;
                    const momentObj = moment(value, "MM/YYYY"); // Parse user input
                    return momentObj.subtract(543, "years").toDate(); // Convert BE to CE
                }
            },

            lang: {
                days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
                months: [
                    "มกราคม",
                    "กุมภาพันธ์",
                    "มีนาคม",
                    "เมษายน",
                    "พฤษภาคม",
                    "มิถุนายน",
                    "กรกฎาคม",
                    "สิงหาคม",
                    "กันยายน",
                    "ตุลาคม",
                    "พฤศจิกายน",
                    "ธันวาคม"
                ],
                pickers: [
                    "ถัดไป 7 วัน",
                    "ถัดไป 30 วัน",
                    "ก่อนหน้า 7 วัน",
                    "ก่อนหน้า 30 วัน"
                ],
                placeholder: {
                    date: "วว/ดด/ปปปป"
                }
            }
        };
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            employeeList: state => {
                return state.Employee.employeeList;
            },
            optionShiftEmployee: state => {
                return state.Common.shift_work_employee;
            },
            search: state => {
                return state.Employee.search;
            },
            dataPaginate: state => {
                return state.Employee.dataPaginate;
            },
            user: state => {
                return state.Auth.user;
            },
            passport_type: state => {
                let thai = { id: 0, name: "ไทย" };
                state.Common.passport_type.unshift(thai);
                //console.log(state.Common.passport_type)
                return state.Common.passport_type;
            }
        })
    },
    methods: {
        empToPDF() {
            let emp_id = "";
            this.emp.employee.forEach((x, i) => {
                if (i > 0) emp_id += "," + x.id;
                else emp_id += x.id;
            });
            let de_id = "";
            this.emp.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            if (emp_id == "" && de_id == "") {
                alert("กรุณาเลือกพนักงานหรือแผนก");
            } else {
                let data = {
                    employee_id: emp_id,
                    department_id: de_id,
                    // date_start : this.emp.date.length > 0 ? moment(this.emp.date[0]).format('YYYY-MM-DD'):'',
                    // date_end : this.emp.date.length > 0 ? moment(this.emp.date[1]).format('YYYY-MM-DD'):'',
                    active_status: this.emp.active,
                    file: "pdf"
                };
                window.open(
                    domain +
                        `/emp_report?employee=${data.employee_id}&department=${data.department_id}&active=${data.active_status}&file=${data.file}`
                );
            }
        },
        empToExcel() {
            let emp_id = "";
            this.emp.employee.forEach((x, i) => {
                if (i > 0) emp_id += "," + x.id;
                else emp_id += x.id;
            });
            let de_id = "";
            this.emp.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            if (emp_id == "" && de_id == "") {
                alert("กรุณาเลือกพนักงานหรือแผนก");
            } else {
                let data = {
                    employee_id: emp_id,
                    department_id: de_id,
                    // date_start : this.emp.date.length > 0 ? moment(this.emp.date[0]).format('YYYY-MM-DD'):'',
                    // date_end : this.emp.date.length > 0 ? moment(this.emp.date[1]).format('YYYY-MM-DD'):'',
                    active_status: this.emp.active,
                    file: "excel"
                };
                window.open(
                    domain +
                        `/emp_report?employee=${data.employee_id}&department=${data.department_id}&active=${data.active_status}&file=${data.file}`
                );
            }
        },
        empNationToPDF() {
            let emp_id = "";
            this.emp_nation.employee.forEach((x, i) => {
                if (i > 0) emp_id += "," + x.id;
                else emp_id += x.id;
            });
            let de_id = "";
            this.emp_nation.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            // let na_id = '';
            // this.emp_nation.nationality.forEach((x, i) => {
            //     if (i > 0) na_id += ',' + x.id
            //     else na_id += x.id
            // })
            if (!emp_id && !de_id) {
                alert("กรุณาเลือกพนักงานหรือแผนก");
            } else {
                let data = {
                    employee_id: emp_id,
                    department_id: de_id,
                    // date_start : this.emp.date.length > 0 ? moment(this.emp.date[0]).format('YYYY-MM-DD'):'',
                    // date_end : this.emp.date.length > 0 ? moment(this.emp.date[1]).format('YYYY-MM-DD'):'',
                    active_status: this.emp_nation.active,
                    nation: this.emp_nation.nationality.join(","),
                    file: "pdf"
                };
                window.open(
                    domain +
                        `/emp_nation_report?employee=${data.employee_id}&department=${data.department_id}&active=${data.active_status}&file=${data.file}&nation=${data.nation}`
                );
            }
        },
        empNationToExcel() {
            let emp_id = "";
            this.emp_nation.employee.forEach((x, i) => {
                if (i > 0) emp_id += "," + x.id;
                else emp_id += x.id;
            });
            let de_id = "";
            this.emp_nation.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            let na_id = "";
            this.emp_nation.nationality.forEach((x, i) => {
                if (i > 0) na_id += "," + x.id;
                else na_id += x.id;
            });

            let data = {
                employee_id: emp_id,
                department_id: de_id,
                // date_start : this.emp.date.length > 0 ? moment(this.emp.date[0]).format('YYYY-MM-DD'):'',
                // date_end : this.emp.date.length > 0 ? moment(this.emp.date[1]).format('YYYY-MM-DD'):'',
                date: this.emp_nation.date,
                active_status: this.emp_nation.active,
                nation: na_id,
                file: "excel"
            };
            window.open(
                domain +
                    `/emp_nation_report_new?employee=${data.employee_id}&department=${data.department_id}&active=${data.active_status}&date=${data.date}&file=${data.file}&nation=${data.nation}`
            );
        },
        empGuaranteeToPDF() {
            let emp_id = "";
            this.emp_guarantee.employee.forEach((x, i) => {
                if (i > 0) emp_id += "," + x.id;
                else emp_id += x.id;
            });
            let de_id = "";
            this.emp_guarantee.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            if (!emp_id && !de_id) {
                alert("กรุณาเลือกพนักงานหรือแผนก");
            } else {
                let data = {
                    employee_id: emp_id,
                    department_id: de_id,
                    // date_start : this.emp.date.length > 0 ? moment(this.emp.date[0]).format('YYYY-MM-DD'):'',
                    // date_end : this.emp.date.length > 0 ? moment(this.emp.date[1]).format('YYYY-MM-DD'):'',
                    active_status: this.emp_guarantee.active,
                    file: "pdf"
                };
                window.open(
                    domain +
                        `/emp_guarantee_report?employee=${data.employee_id}&department=${data.department_id}&active=${data.active_status}&file=${data.file}`
                );
            }
        },
        empGuaranteeToExcel() {
            let emp_id = "";
            this.emp_guarantee.employee.forEach((x, i) => {
                if (i > 0) emp_id += "," + x.id;
                else emp_id += x.id;
            });
            let de_id = "";
            this.emp_guarantee.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            if (!emp_id && !de_id) {
                alert("กรุณาเลือกพนักงานหรือแผนก");
            } else {
                let data = {
                    employee_id: emp_id,
                    department_id: de_id,
                    // date_start : this.emp.date.length > 0 ? moment(this.emp.date[0]).format('YYYY-MM-DD'):'',
                    // date_end : this.emp.date.length > 0 ? moment(this.emp.date[1]).format('YYYY-MM-DD'):'',
                    active_status: this.emp_guarantee.active,
                    file: "excel"
                };
                window.open(
                    domain +
                        `/emp_guarantee_report?employee=${data.employee_id}&department=${data.department_id}&active=${data.active_status}&file=${data.file}`
                );
            }
        },
        empNationalityToPDF() {
            let emp_id = "";
            this.emp_nationality.employee.forEach((x, i) => {
                if (i > 0) emp_id += "," + x.id;
                else emp_id += x.id;
            });
            let de_id = "";
            this.emp_nationality.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            let na_id = "";
            this.emp_nationality.passport_type.forEach((x, i) => {
                if (i > 0) na_id += "," + x.id;
                else na_id += x.id;
            });
            let data = {
                employee_id: emp_id,
                department_id: de_id,
                nation_id: na_id,
                // date_start : this.emp.date.length > 0 ? moment(this.emp.date[0]).format('YYYY-MM-DD'):'',
                // date_end : this.emp.date.length > 0 ? moment(this.emp.date[1]).format('YYYY-MM-DD'):'',
                active_status: this.emp_nationality.active,
                file: "pdf"
            };
            window.open(
                domain +
                    `/emp_nationality_report?employee=${data.employee_id}&department=${data.department_id}&nation_id=${data.nation_id}&active=${data.active_status}&file=${data.file}`
            );
        },
        empNationalityToExcel() {
            let emp_id = "";
            this.emp_nationality.employee.forEach((x, i) => {
                if (i > 0) emp_id += "," + x.id;
                else emp_id += x.id;
            });
            let de_id = "";
            this.emp_nationality.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            let na_id = "";
            this.emp_nationality.passport_type.forEach((x, i) => {
                if (i > 0) na_id += "," + x.id;
                else na_id += x.id;
            });
            let data = {
                employee_id: emp_id,
                department_id: de_id,
                nation_id: na_id,
                // date_start : this.emp.date.length > 0 ? moment(this.emp.date[0]).format('YYYY-MM-DD'):'',
                // date_end : this.emp.date.length > 0 ? moment(this.emp.date[1]).format('YYYY-MM-DD'):'',
                active_status: this.emp_nationality.active,
                file: "excel"
            };
            window.open(
                domain +
                    `/emp_nationality_report?employee=${data.employee_id}&department=${data.department_id}&nation_id=${data.nation_id}&active=${data.active_status}&file=${data.file}`
            );
        },
        empLeaveToPDF() {
            // let emp_id = '';
            // this.emp_nationality.employee.forEach((x,i) => {
            //     if(i>0)emp_id += ','+x.id
            //     else emp_id += x.id
            // })
            let de_id = "";
            this.emp_leave.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            let data = {
                // employee_id : emp_id,
                department_id: de_id,
                date_start:
                    this.emp_leave.date.length > 0
                        ? moment(this.emp_leave.date[0]).format("YYYY-MM-DD")
                        : "",
                date_end:
                    this.emp_leave.date.length > 0
                        ? moment(this.emp_leave.date[1]).format("YYYY-MM-DD")
                        : "",
                // active_status : this.emp_nationality.active,
                file: "pdf"
            };
            window.open(
                domain +
                    `/emp_leave_report?department=${data.department_id}&date_start=${data.date_start}&date_end=${data.date_end}&file=${data.file}`
            );
        },
        empLeaveToExcel() {
            // let emp_id = '';
            // this.emp_nationality.employee.forEach((x,i) => {
            //     if(i>0)emp_id += ','+x.id
            //     else emp_id += x.id
            // })
            let de_id = "";
            this.emp_leave.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            let data = {
                // employee_id : emp_id,
                department_id: de_id,
                date_start:
                    this.emp_leave.date.length > 0
                        ? moment(this.emp_leave.date[0]).format("YYYY-MM-DD")
                        : "",
                date_end:
                    this.emp_leave.date.length > 0
                        ? moment(this.emp_leave.date[1]).format("YYYY-MM-DD")
                        : "",
                // active_status : this.emp_nationality.active,
                file: "excel"
            };
            window.open(
                domain +
                    `/emp_leave_report?department=${data.department_id}&date_start=${data.date_start}&date_end=${data.date_end}&file=${data.file}`
            );
        },
        empTaxToPDF() {
            let emp_id = "";
            this.emp_tax.employee.forEach((x, i) => {
                if (i > 0) emp_id += "," + x.id;
                else emp_id += x.id;
            });
            let de_id = "";
            this.emp_tax.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            let data = {
                employee_id: emp_id,
                department_id: de_id,
                date_start:
                    this.emp_tax.date.length > 0
                        ? moment(this.emp_tax.date[0]).format("YYYY-MM-DD")
                        : "",
                date_end:
                    this.emp_tax.date.length > 0
                        ? moment(this.emp_tax.date[1]).format("YYYY-MM-DD")
                        : "",
                file: "pdf"
            };
            window.open(
                domain +
                    `/emp_tax_report?employee=${data.employee_id}&department=${data.department_id}&date_start=${data.date_start}&date_end=${data.date_end}&file=${data.file}`
            );
        },
        empTaxToExcel() {
            let emp_id = "";
            this.emp_tax.employee.forEach((x, i) => {
                if (i > 0) emp_id += "," + x.id;
                else emp_id += x.id;
            });
            let de_id = "";
            this.emp_tax.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            let data = {
                employee_id: emp_id,
                department_id: de_id,
                date_start:
                    this.emp_tax.date.length > 0
                        ? moment(this.emp_tax.date[0]).format("YYYY-MM-DD")
                        : "",
                date_end:
                    this.emp_tax.date.length > 0
                        ? moment(this.emp_tax.date[1]).format("YYYY-MM-DD")
                        : "",
                file: "excel"
            };
            window.open(
                domain +
                    `/emp_tax_report?employee=${data.employee_id}&department=${data.department_id}&date_start=${data.date_start}&date_end=${data.date_end}&file=${data.file}`
            );
        },
        empHistoryToPDF() {
            let emp_id = "";
            this.emp_history.employee.forEach((x, i) => {
                if (i > 0) emp_id += "," + x.id;
                else emp_id += x.id;
            });
            let de_id = "";
            this.emp_history.department.forEach((x, i) => {
                if (i > 0) de_id += "," + x.id;
                else de_id += x.id;
            });
            let data = {
                employee_id: emp_id,
                department_id: de_id,
                file: "pdf"
            };
            window.open(
                domain +
                    `/emp_history_report?department=${data.department_id}&employee=${data.employee_id}&file=${data.file}`
            );
        },
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}(${
                option.english_name ? option.english_name : ""
            })`;
        },
        getEmployeeAll() {
            this.$store.dispatch("Employee/getEmployeeAll").then(res => {
                this.optionEmployee = res;
            });
        },
        getDepartmentAll() {
            this.$store.dispatch("Department/getAllDepartment").then(res => {
                this.optionDepartmentEmp = res;

                this.optionDepartment = [
                    {
                        value: "",
                        text: "เลือกแผนก"
                    },
                    ...res.map(data => ({
                        value: data.id,
                        text: data.department_name
                    }))
                ];
            });
        },
        showApproveModal(id) {
            this.employee_id = id;
            this.$refs.approve.show();
        },
        showApproveResignModal(id) {
            this.employee_id_resign = id;
            this.$refs.resign.show();
        },
        showFilterListModal() {
            this.$refs.filter_list.show();
        },
        showFilterModal() {
            this.$refs.filter_emp.show();
        },
        showFilterNationModal() {
            this.$refs.filter_emp_nation.show();
        },
        showFilterNationalityModal() {
            this.$refs.filter_emp_nationality.show();
        },
        showFilterLeaveModal() {
            this.$refs.filter_emp_leave.show();
        },
        showFilterHistoryModal() {
            this.$refs.filter_history_leave.show();
        },
        showFilterTaxEmployeeModal() {
            this.$refs.filter_tax_employee.show();
        },
        showFilterGuaranteeModal() {
            this.$refs.filter_emp_guarantee.show();
        },
        hideFilterListModal() {
            this.$refs.filter_list.hide();
        },
        hideFilterTaxEmployeeModal() {
            this.$refs.filter_tax_employee.hide();
        },
        hideApproveModal() {
            this.$refs.approve.hide();
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        addEmployee() {
            this.$store.dispatch("Employee/clearData");
            this.$router.push({
                name: "employee-information-profile"
            });
        },
        editEmployee(id) {
            this.$store.dispatch("Employee/getEmployeeByID", id).then(() => {
                this.$router.push({
                    name: "employee-information-profile",
                    params: { id }
                });
            });
        },
        filterExpire(value) {
            if (value) {
                this.$store
                    .dispatch("Employee/exportExpireEmployee", value)
                    .then(url => {
                        window.open(url, "_blank");
                    });
            }
            this.hideFilterListModal();
        },
        deleteEmployee(value) {
            if (value) {
                if (this.delete_id) {
                    this.$store
                        .dispatch("Employee/deleteEmployee", this.delete_id)
                        .then(() => {
                            this.$store
                                .dispatch("Employee/setEmployee")
                                .then(() => {
                                    alert("ลบรายการสำเร็จ");
                                });
                        })
                        .catch(() => {
                            alert("ลบรายการไม่สำเร็จ");
                        });
                }
            }
            this.hideDeleteModal();
        },
        searchEmployee() {
            this.event_submit = true;
            let data = {
                passport: this.search.passport,
                department: this.search.department,
                status: this.search.status,
                shift: this.search.shift ? this.search.shift.id : "",
                insurance_card_number: this.search.insurance_card_number,
                myanmar_list: this.search.myanmar_list,
                employee: this.search.employee ? this.search.employee.id : "",
                active: this.search.active ? this.search.active : ""
            };
            this.$store.dispatch("Employee/search", data);
        },
        getEmployee() {
            const page = this.dataPaginate.current_page;
            let data = {
                page: page,
                passport: this.search.passport,
                department: this.search.department,
                status: this.search.status,
                shift: this.search.shift ? this.search.shift.id : "",
                insurance_card_number: this.search.insurance_card_number,
                myanmar_list: this.search.myanmar_list,
                employee: this.search.employee ? this.search.employee.id : "",
                active: this.search.active ? this.search.active : ""
            };
            //                //paginate search
            if (this.event_submit) {
                this.$store.dispatch("Employee/search", data);
            } else {
                //paginate get data
                this.$store.dispatch("Employee/setEmployee", page);
            }
        },
        approveEmployee(val) {
            if (val && this.employee_id) {
                let data = {
                    id: this.employee_id
                };
                this.$store
                    .dispatch("Employee/approveEmployee", data)
                    .then(() => {
                        alert("อนุมัติพนักงานสำเร็จ");
                        this.getEmployee();
                    })
                    .catch(err => {
                        alert("อนุมัติไม่สำเร็จ กรุณาลองอีกครั้ง");
                    });
            }
            this.hideApproveModal();
        },
        approveResignEmployee(val) {
            if (val && this.employee_id_resign) {
                let data = {
                    id: this.employee_id_resign,
                    user: this.user.name
                };
                this.$store
                    .dispatch("Employee/approveResignEmployee", data)
                    .then(() => {
                        alert("อนุมัติลาออกพนักงานสำเร็จ");
                        this.getEmployee();
                    })
                    .catch(err => {
                        alert("อนุมัติลาออกไม่สำเร็จ กรุณาลองอีกครั้ง");
                    });
            }
            this.$refs.resign.hide();
        },
        customLabel(option) {
            let shift_work = "";
            let day_off = "";
            if (option.shift_work_id == 1) {
                shift_work = "กะกลางวัน";
            } else if (option.shift_work_id == 2) {
                shift_work = "กะกลางคืน";
            }

            if (option.day_off_id == 1) {
                day_off = "วันจันทร์";
            } else if (option.day_off_id == 2) {
                day_off = "วันอังคาร";
            } else if (option.day_off_id == 3) {
                day_off = "วันพุธ";
            } else if (option.day_off_id == 4) {
                day_off = "วันพฤหัส";
            } else if (option.day_off_id == 5) {
                day_off = "วันศุกร์";
            } else if (option.day_off_id == 6) {
                day_off = "วันเสาร์";
            } else if (option.day_off_id == 7) {
                day_off = "วันอาทิตย์";
            }

            return `${shift_work} หยุด ${day_off}`;
        }
    }
};
</script>

<style scoped>
.select {
    border: 0;
}
</style>
